import { CellTable } from "@/atoms"
import { CELLS, getDefaultColumnParams } from "@/helpers/table.helpers"
import { HeaderCell } from "@/molecules/HeaderCell"
import { ImpactCell } from "@/molecules/ImpactCell"
import { LanguageIconCell } from "@/molecules/LanguageIconCell"
import { MoreTableCell } from "@/molecules/MoreTableCell"
import { ResourcesCell } from "@/molecules/Resources"
import { InsightsSbomCell } from "../../molecules/InsightsSbomCell"
import { PackageTooltip } from "./PackageTooltip"

import type { ColumnsProps } from "."

export const getColumnsTable = (props: ColumnsProps) => {
  const { orderByProps, placement, onRowClick, previewMode } = props
  const isDrawer = placement === "drawer"
  const projectRender = isDrawer
    ? ResourcesCell({ inline: true, ...props })
    : CellTable
  const projectFieldName = isDrawer ? "resources" : "projects"

  const columns = [
    {
      title: isDrawer
        ? "Package"
        : HeaderCell({ title: "Package", Content: PackageTooltip }),
      render: LanguageIconCell,
      ...getDefaultColumnParams("name", orderByProps)
    },
    {
      title: "Version",
      width: 100,
      render: CellTable,
      ...getDefaultColumnParams("version", orderByProps)
    },
    {
      title: "License",
      width: 120,
      render: MoreTableCell,
      ...getDefaultColumnParams("license", orderByProps)
    },
    CELLS.getIssuesSummaryCell(props, {
      title: "Vulnerabilities",
      ...getDefaultColumnParams("issuesSummary", orderByProps)
    }),
    {
      title: "Insights",
      width: 120,
      render: InsightsSbomCell(props),
      ...getDefaultColumnParams("insights")
    },
    {
      title: "Projects",
      width: 150,
      render: projectRender,
      ...getDefaultColumnParams(projectFieldName, orderByProps, {
        customSorterName: "projectsCount"
      })
    },
    {
      title: "Apps",
      width: 70,
      render: ImpactCell({ onRowClick }),
      className: "center-align-tab-template-component",
      ...getDefaultColumnParams("applicationsCount")
    },
    CELLS.getLastDetectedCell({
      entityName: "package",
      t: props.t,
      width: 140,
      ...getDefaultColumnParams("lastDetectionData")
    })
  ]

  if (isDrawer) {
    return columns.filter(({ key }) => key !== "resources")
  }
  if (previewMode) {
    return columns.filter(
      ({ key }) => key !== "lastDetectionData" && key !== "license"
    )
  }
  return columns
}
